import React, { useEffect, useState } from "react";

const API = "https://reflex-backend.alfaoir1.workers.dev";

export default function DiagnosticSubmissions() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchForms = () => {
      fetch(`${API}/diagnostic-form`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setForms(data.forms || []);
          } else {
            setError("Failed to load diagnostic forms.");
          }
          setLoading(false);
        })
        .catch(() => {
          setTimeout(() => {
            fetch(`${API}/diagnostic-form`)
              .then((res) => res.json())
              .then((data) => {
                if (data.success) {
                  setForms(data.forms || []);
                } else {
                  setError("Failed to load diagnostic forms.");
                }
                setLoading(false);
              })
              .catch(() => {
                setError("Connection to backend failed.");
                setLoading(false);
              });
          }, 1000);
        });
    };

    fetchForms();
  }, []);

  return (
    <div style={s.page}>
      <div style={s.header}>
        <p style={s.label}>Admin Panel</p>

        <h1 style={s.title}>Diagnostic Form Submissions</h1>

        <p style={s.sub}>
          All submitted diagnostic forms are shown below.
        </p>
      </div>

      <div style={s.content}>
        {loading && <p style={s.msg}>Loading...</p>}

        {error && <p style={s.err}>{error}</p>}

        {!loading && !error && (
          <>
            <p style={s.count}>
              {forms.length} submission{forms.length !== 1 ? "s" : ""}
            </p>

            {forms.length === 0 ? (
              <p style={s.msg}>No diagnostic form submissions found.</p>
            ) : (
              <div style={s.tableWrap}>
                <table style={s.table}>
                  <thead>
                    <tr>
                      <th style={s.th}>#</th>
                      <th style={s.th}>Name</th>
                      <th style={s.th}>Email</th>
                      <th style={s.th}>Phone</th>
                      <th style={s.th}>Submitted</th>
                    </tr>
                  </thead>

                  <tbody>
                    {forms.map((f, i) => (
                      <tr
                        key={f._id || i}
                        style={{ ...s.row, cursor: "pointer" }}
                        onClick={() => console.log(f)}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#1a0d2e")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={s.td}>{i + 1}</td>

                        <td style={{ ...s.td, color: "#a855f7", fontWeight: 600 }}>
                          {f.fullName || "—"}
                        </td>

                        <td style={s.td}>{f.email || "—"}</td>

                        <td style={s.td}>{f.phone || "—"}</td>

                        <td style={s.td}>
                          {f.submittedAt
                            ? new Date(f.submittedAt).toLocaleDateString()
                            : "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page: {
    background: "#0a0a0f",
    minHeight: "100vh",
    color: "#fff",
    fontFamily: "Inter, sans-serif",
  },

  header: {
    background: "linear-gradient(135deg, #0f0a1e, #1a0d2e)",
    padding: "60px 40px 40px",
    borderBottom: "1px solid #1f1f2e",
  },

  label: {
    fontSize: "12px",
    color: "#a855f7",
    textTransform: "uppercase",
    letterSpacing: "3px",
    margin: "0 0 10px",
  },

  title: {
    fontSize: "32px",
    fontWeight: 800,
    margin: "0 0 8px",
  },

  sub: {
    fontSize: "15px",
    color: "#6b7280",
    margin: 0,
  },

  content: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "40px 20px",
  },

  count: {
    fontSize: "13px",
    color: "#6b7280",
    marginBottom: "16px",
  },

  tableWrap: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    textAlign: "left",
    padding: "12px 16px",
    fontSize: "11px",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "1px",
    borderBottom: "1px solid #1f1f2e",
  },

  row: {
    borderBottom: "1px solid #1f1f2e",
    transition: "background 0.15s",
  },

  td: {
    padding: "14px 16px",
    fontSize: "14px",
    color: "#d1d5db",
  },

  msg: {
    color: "#6b7280",
    textAlign: "center",
    padding: "60px 0",
  },

  err: {
    color: "#ef4444",
    background: "rgba(239,68,68,0.1)",
    border: "1px solid rgba(239,68,68,0.2)",
    borderRadius: "8px",
    padding: "14px 18px",
  },
};